import { render, staticRenderFns } from "./noticeprint.vue?vue&type=template&id=76e6ff4f"
import script from "./noticeprint.vue?vue&type=script&lang=js"
export * from "./noticeprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports